import {ENDPOINT_ADMIN} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';


const logAction = (body) => {
  return fetch(
    `${ENDPOINT_ADMIN}log`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify(body),
    }
  );    
};

export default {
  logAction,
};
